<template>
  <div>
    <!--<div class="table-responsive">
      <table
        class="table table-border"
        style="margin-bottom: 12px;"
      >
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">B/L {{ year }}</th>
            <th v-bind:class="{'active-month': currentMonth == 1}"   scope="col">Jan</th>
            <th v-bind:class="{'active-month': currentMonth == 2}"   scope="col">Feb</th>
            <th v-bind:class="{'active-month': currentMonth == 3}"   scope="col">Mar</th>
            <th v-bind:class="{'active-month': currentMonth == 4}"   scope="col">Apr</th>
            <th v-bind:class="{'active-month': currentMonth == 5}"   scope="col">May</th>
            <th v-bind:class="{'active-month': currentMonth == 6}"   scope="col">Jun</th>
            <th v-bind:class="{'active-month': currentMonth == 7}"   scope="col">Jul</th>
            <th v-bind:class="{'active-month': currentMonth == 8}"   scope="col">Aug</th>
            <th v-bind:class="{'active-month': currentMonth == 9}"   scope="col">Sep</th>
            <th v-bind:class="{'active-month': currentMonth == 10}"  scope="col">Oct</th>
            <th v-bind:class="{'active-month': currentMonth == 11}"  scope="col">Nov</th>
            <th v-bind:class="{'active-month': currentMonth == 12}"  scope="col">Dec</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td  scope="row">
              <strong>
                <div
                  style="
                   
                    font-size: 20px;
                    font-family: inherit;
                    font-weight: 400;
                    line-height: 1;
                  "
                  v-tooltip:left="toolTipText"
                >
                  Cash Desk
                </div>
              </strong>
            </td>
            <td v-bind:class="{'active-month-column': currentMonth == (key2)}"
            
              v-for="(fee, key2) in cashBalanceFees"
              :key="fee" v-if="key2 < 13"
            >
              <div v-if="key2 < 13">
                <div v-if="key2 > currentMonth">-</div>
                <div v-else>
                  <div v-if="key2 < currentMonth && key2 > 0">
                    <div v-if="fee == 0">-</div>
                    <div v-else>{{ fee.toFixed(2) }}</div>
                  </div>
                  <div v-else>
                    <div v-if="fee == 0">-</div>
                    <div v-else>{{ fee.toFixed(2) }}</div>
                  </div>
                </div>
              </div>
              
            </td>
          </tr>
        </tbody>
      </table>
    </div>-->
    <div class="table-responsive" style="margin-top:20px;">
      <table class="table table-border">
        <thead>
          <tr>
            <th scope="col">Cash Balance</th>
            <th scope="col">B/L {{ year }}</th>
            <th v-bind:class="{'active-month': currentMonth == 1}"  scope="col">Jan</th>
            <th v-bind:class="{'active-month': currentMonth == 2}"  scope="col">Feb</th>
            <th v-bind:class="{'active-month': currentMonth == 3}"  scope="col">Mar</th>
            <th v-bind:class="{'active-month': currentMonth == 4}"  scope="col">Apr</th>
            <th v-bind:class="{'active-month': currentMonth == 5}"  scope="col">May</th>
            <th v-bind:class="{'active-month': currentMonth == 6}"  scope="col">Jun</th>
            <th v-bind:class="{'active-month': currentMonth == 7}"  scope="col">Jul</th>
            <th v-bind:class="{'active-month': currentMonth == 8}"  scope="col">Aug</th>
            <th v-bind:class="{'active-month': currentMonth == 9}"  scope="col">Sep</th>
            <th v-bind:class="{'active-month': currentMonth == 10}" scope="col">Oct</th>
            <th v-bind:class="{'active-month': currentMonth == 11}" scope="col">Nov</th>
            <th v-bind:class="{'active-month': currentMonth == 12}" scope="col">Dec</th>
            <!--<th scope="col">Total</th>-->
          </tr>
        </thead>
        <tbody>
            <tr v-for="propertyFee in getProperties" v-bind:key="propertyFee.id">
                <td scope="row">
                   
                        <div v-if="propertyFee.is_building">
                            <a :href="'/admin/statment/' + propertyFee.propertyId">
                                {{
                    propertyFee.propertyName
                                }}
                            </a>
                        </div>
                        <div v-tooltip:left="toolTipText">
                            {{ propertyFee.propertyName }}
                        </div>
                   
                </td>
                <template v-for="(fee, key2) in propertyFee.fees" :key="key2"><td v-bind:class="{'active-month-column': currentMonth == (key2)}" v-if="key2 <= 12">
                    <div v-if="key2 <= 12">
                        <div v-if="key2 > currentMonth">-</div>
                        <div v-else>
                            <div v-if="key2 < currentMonth && key2 > 0">
                                <div v-if="fee == 0">-</div>
                                <div v-else>{{ $filters.toCurrency(fee) }}</div>
                            </div>
                            <div v-else>
                                <div v-if="fee == 0">-</div>
                                <div v-else>{{ $filters.toCurrency(fee) }}</div>
                            </div>
                        </div>
                    </div>
                    <!--<div v-else>
              <strong>
                <div v-if="fee == 0">-</div>
                <div v-else>{{ fee.toFixed(2) }}</div>
              </strong>
            </div>-->
                </td></template>
            </tr>
            <tr >
                <td scope="row">
                    <strong>
                       
                        <div v-tooltip:left="toolTipText">
                            Total
                        </div>
                    </strong>
                </td>
                <template v-for="(fee, key2) in totalFees" :key="key2"><td v-bind:class="{'active-month-column': currentMonth == (key2)}" v-if="key2 <= 12">
                    <strong>
                        <div v-if="key2 <= 12">
                            <div v-if="key2 > currentMonth">-</div>
                            <div v-else>
                                <div v-if="key2 < currentMonth && key2 > 0">
                                    <div v-if="fee == 0">-</div>
                                    <div v-else>{{ $filters.toCurrency(fee) }}</div>
                                </div>
                                <div v-else>
                                    <div v-if="fee == 0">-</div>
                                    <div v-else>{{ $filters.toCurrency(fee) }}</div>
                                </div>
                            </div>
                        </div>
                        <!--<div v-else>
      <strong>
        <div v-if="fee == 0">-</div>
        <div v-else>{{ fee.toFixed(2) }}</div>
      </strong>
    </div>-->
                    </strong>
                </td></template>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { authenticationService } from "@/_services";

export default {
  props: ["buildingId", "route", "period", "filter", "dark"],
  data: function () {
    return {
      propertyFees: [],
        totalFees: [],
      cashBalanceFees:[],
      index: 0,
      isModalVisible: true,
      propertyId: 0,
      monthParam: 0,
      currentMonth: 0,
      year: 0,
      currentUser: null,
    };
  },
  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      this.fetchStatement();
    },
  },
  beforeCreate() {
  },

  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
  },
  mounted() {
    if (!this.$period.isCurrent(this.period)) {
      this.currentMonth = 12;
      this.year = new Date().getFullYear() - Number(this.period);
    } else {
      this.year = new Date().getFullYear() - 1;
      this.currentMonth = new Date().getMonth() + 1;
    }

    if (this.buildingId) this.fetchStatement();

    //this.propertyHistory = JSON.parse(this.propertyAttribute)

    //console.log(this.propertyAttribute)
    //this.propertyHistory = this.propertyAttribute
  },

  methods: {
    beforeOpen(event) {
      this.propertyId = event.params.creditortypeid;
      this.monthParam = event.params.month + 1;
    },
    showModal() {
      this.isModalVisible = true;
      alert(this.isModalVisible);
    },
    closeModal() {
      this.isModalVisible = false;
    },

    fetchStatement: function () {
      this.mute = true;
      var request = "/statement/outstanding";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      /* if (this.currentUser.role === "Owner")
        request =
          request +
          "/owner?id=" +
          this.buildingId +
          "&userid=" +
          this.currentUser.id +
          "&period=" +
          this.period;
      else*/
      request = request + "?id=" + this.buildingId + "&period=" + this.period;
      /*  if(this.period == 2)	
                    request = request +'/'+this.period;
                else
                    request = request +'?id='+this.buildingId;*/

      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.propertyFees = data.propertyFees;
            this.totalFees = data.totalFees;
            this.cashBalanceFees = data.cashBalanceFees;
        });
    },
    showModalTemp: function (propertyId, month) {
      //this.$modal.show('creditors-form', { 'creditortypeid': creditorId,  'month' : month});
      //alert("Id " + expenseId + " month " + month);
      //this.isModalVisible = true;
    },
    show() {
      // this.$modal.show('creditors-form');
    },
    hide() {
      // this.$modal.hide('creditors-form');
    },

    /**
     * Prepare the component.
     */
  },

  computed: {
    getProperties() {
      var propertyFees = this.propertyFees.filter((propertyFee) => {
        if (this.filter)
          return propertyFee.propertyName
            .toLowerCase()
            .includes(this.filter.toLowerCase());
        else return this.propertyFees;
      });

      return propertyFees;
    },
    // to write to show the owner of property when we hover over the property number
    getPropertyOwner() {
      return null;
    },
    total: function () {
      return this.propertyFees[0].reduce(function (total, fees) {
        return total + fees[0];
      }, 0);
    },
    toolTipText: function () {
      return this.getPropertyOwner;
    },
  },
}; // Our Javascript logic
</script>
